
function PixelConversion( PurchasePrice, PurchaseCurrency, ConfirmationNumber,DepartureDate, ReturnDate, DestinationCity, 
    DestinationStateorRegion, DestinationCountry, AttractionName, NumberOfTravelers) {
    /* Please fill the following values. */
var params = {
    vd1: DepartureDate, /* Departure Date */
    vd2: ReturnDate, /* Return Date */
    vf1: DestinationCity, /* Destination City */
    vs1: DestinationStateorRegion, /* Destination State or Region */
    vn1: DestinationCountry, /* Destination Country */
    vb: AttractionName, /* Attraction Name */
    t: NumberOfTravelers, /* Number of Travelers */
    vp: PurchasePrice, /* Purchase Price */
    vcu: PurchaseCurrency, /* Purchase Currency */
    vconfno: ConfirmationNumber /* Confirmation Number */

    };
    
    /* Please do not modify the below code. */
    var cid = [];
    var paramsArr = [];
    var cidParams = [];
    var pl = document.createElement('script');
    var defaultParams = {"vid":"tou","et":"vc"};
    for(key in defaultParams) { params[key] = defaultParams[key]; };
    for(key in cidParams) { cid.push(params[cidParams[key]]); };
    params.cid = cid.join('|');
    for(key in params) { paramsArr.push(key + '=' + encodeURIComponent(params[key])) };
    pl.type = 'text/javascript';
    pl.async = true;
    pl.src = 'https://beacon.sojern.com/pixel/p/278387?f_v=v6_js&p_v=1&' + paramsArr.join('&');
    (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(pl);
    
}

function PixelShopping(DepartureDate, ReturnDate, DestinationCity, 
    DestinationStateorRegion, DestinationCountry, AttractionName, NumberOfTravelers) {

    /* Please fill the following values. */
    var params = {
        vd1: DepartureDate, /* Departure Date */
        vd2: ReturnDate, /* Return Date */
        vf1: DestinationCity, /* Destination City */
        vs1: DestinationStateorRegion, /* Destination State or Region */
        vn1: DestinationCountry, /* Destination Country */
        vb: AttractionName, /* Attraction Name */
        t: NumberOfTravelers /* Number of Travelers */
    };

    /* Please do not modify the below code. */
    var cid = [];
    var paramsArr = [];
    var cidParams = [];
    var pl = document.createElement('script');
    var defaultParams = { "vid": "tou", "et": "vcart" };
    for (key in defaultParams) { params[key] = defaultParams[key]; };
    for (key in cidParams) { cid.push(params[cidParams[key]]); };
    params.cid = cid.join('|');
    for (key in params) { paramsArr.push(key + '=' + encodeURIComponent(params[key])) };
    pl.type = 'text/javascript';
    pl.async = true;
    pl.src = 'https://beacon.sojern.com/pixel/p/278385?f_v=v6_js&p_v=1&' + paramsArr.join('&');
    (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(pl);

   
}

function PixelSearch(DepartureDate, ReturnDate, DestinationCity, 
    DestinationStateorRegion, DestinationCountry,  NumberOfTravelers) {

    /* Please fill the following values. */
    var params = {
        vd1: DepartureDate, /* Departure Date */
        vd2: ReturnDate, /* Return Date */
        vf1: DestinationCity, /* Destination City */
        vs1: DestinationStateorRegion, /* Destination State or Region */
        vn1: DestinationCountry, /* Destination Country */
        t: NumberOfTravelers, /* Number of Travelers */
        cid:"1"
    };

    try {
        /* Please do not modify the below code. */
        var cid = [];
        var paramsArr = [];
        var cidParams = [];
        var pl = document.createElement('script');
        var defaultParams = { "vid": "tou", "et": "vs" };
        for (key in defaultParams) { params[key] = defaultParams[key]; };
        for (key in cidParams) { cid.push(params[cidParams[key]]); };
        params.cid = cid.join('|');
        for (key in params) { paramsArr.push(key + '=' + encodeURIComponent(params[key])) };
        pl.type = 'text/javascript';
        pl.async = true;
        pl.src = 'https://beacon.sojern.com/pixel/p/278383?f_v=v6_js&p_v=1&' + paramsArr.join('&');
        (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(pl);
    }
    catch (error) {
        console.error(error);
    }
}

